// extracted by mini-css-extract-plugin
module.exports = {"component":"Title_component__a1pLG","xl":"Title_xl__XneG5","light":"Title_light__KOm2L","lg":"Title_lg__RU3TK","md":"Title_md__UIui_","sm":"Title_sm__SnObp","xs":"Title_xs__A4JZV"};